export const infoFaqForSunwebUK = [
  {
    title: 'Why has my payment been declined?',
    text:
      'The payment may have failed for different reasons:<br />\n'
      + '<br />\n'
      + '- It might be related to the limit of your credit card which does not allow you to make the payment for this holiday.<br />\n'
      + '- It might be related to the authorization procedure with your bank or credit card company. For example, (incorrect information, too many attempts, connection problems between financial institutions, etc.)<br />\n'
      + '- It might be related to a technical problem with your bank or the payment platform.<br />\n'
      + '- There is also a very unlikely scenario where it comes from our side. It could be that the reservation was not successful but the payment worked. If so, we apologize for the inconvenience.&nbsp; Please contact us as soon as possible via info@sunweb.co.uk and we will refund the debited amount immediately.&nbsp;',
  },
  {
    title: 'What happens to my reservation if I don\'t pay now?',
    text: '<p>If you don\'t pay, your booking will not be confirmed.</p>\n'
      + '<p>If flights are included in your booking, you will be required to pay for these in addition to the standard deposit before your booking is confirmed in this booking step. If booking more than 6 weeks before departure, you will need to pay a 30% deposit. If you book your holiday within 6 weeks of departure, the full amount will be payable to confirm your holiday.&nbsp;</p>\n'
      + '<br />\n',
  },
]
